export default function ContactUsDialogController(
  addSupportTicketDialog,
  ssDialogService,  
  loaderService,
  orgDataService,
) {
  const vm = this;

  vm.handleContactUsSubmit = handleContactUsSubmit;
  vm.handleCloseDialogClick = handleCloseDialogClick;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleContactUsSubmit() {
    _closeDialog();
  }

  function handleCloseDialogClick() {
    _closeDialog();
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
    return orgDataService.getCurrentCustomer().then((response) => {
      loaderService.showViewLoader = false;
      vm.customer = response.data;
      if (vm.customer.customerType.customerTypeId === 1) {
        _setSafeSystemsDisplayList();
      } else {
        _setNavantaDisplayList();
      }
    });
  }

  function _setSafeSystemsDisplayList(){
    vm.displayList = {
      contactItems: [
        {
          iconName: 'call',
          innerHtml: 'Call us at<br /><a class="tdn" href="tel:770-752-5440">(770) 752-5440</a>',
          onClick: () => {},
        },
        {
          iconName: 'build',
          // innerHtml: "<a href='https://portal.safesystems.com/' target='_BLANK'>Submit a support ticket</a>",
          innerHtml: '<div ng-click="contact.onClick()">Submit a support ticket</div>',
          onClick: _openSupportTicket,
        },
        {
          iconName: 'mail_outline',
          innerHtml: '<a class="tdn" href="https://web1.zixmail.net/s/login?b=safesystems" target="_blank">'
            + 'Send an encrypted email</a><br />via ZixCorp',
          onClick: () => {},
        },
        {
          iconName: 'map',
          // eslint-disable-next-line
          innerHtml: '<a class="tdn" href="https://www.google.com/maps/place/UFS/@43.317568,-87.9323493,18z/data=!4m15!1m8!3m7!1s0x8804e8ad20cef7b3:0x7200c94ab3106ed2!2s2230+Dakota+Dr,+Grafton,+WI+53024!3b1!8m2!3d43.3180696!4d-87.9321776!16s%2Fg%2F11b8v65pmm!3m5!1s0x8804e8ace0435e03:0xa73610537b7fd0d2!8m2!3d43.3177262!4d-87.9325181!16s%2Fg%2F1vgx19_w?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D" ' +
            'target="_blank">2230 Dakota Drive<br />Grafton, WI 53024</a>',
          onClick: () => {},
        }]
    };
  }

  function _setNavantaDisplayList(){
    vm.displayList = {
      contactItems: [
        {
          iconName: 'call',
          innerHtml: 'Call us at<br /><a href="tel:770-752-5440">(770) 752-5440</a>',
          onClick: () => {},
        },
        {
          iconName: 'map',
          // eslint-disable-next-line
          innerHtml: '<a href="https://www.google.com/maps/place/2230+Dakota+Dr,+Grafton,+WI+53024/@43.3180696,-87.9347525,17z/data=!4m15!1m8!3m7!1s0x8804e8ad20cef7b3:0x7200c94ab3106ed2!2s2230+Dakota+Dr,+Grafton,+WI+53024!3b1!8m2!3d43.3180696!4d-87.9321776!16s%2Fg%2F11b8v65pmm!3m5!1s0x8804e8ad20cef7b3:0x7200c94ab3106ed2!8m2!3d43.3180696!4d-87.9321776!16s%2Fg%2F11b8v65pmm?entry=ttu&g_ep=EgoyMDI1MDIyNS4wIKXMDSoASAFQAw%3D%3D" ' +
            'target="_blank">2230 Dakota Dr<br />Grafton, WI 53024</a>',
          onClick: () => {},
        }]
    };
  }

  function _openSupportTicket($event) {
    const ticket = {
      id: '',
      priorityId: '',
      title: '',
      description: '',
      contactId: '',
      statusId: '',
      serviceRequestType: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      past30Days: 'no',
      affectingMultiple: 'no',
      contactDetails: ''
    };
    return _showEditSupportTicketDialog($event, ticket);
  }

  function _showEditSupportTicketDialog($event, ticket) {
    ssDialogService.dialogs.support.addSupportTicketDialog = ssDialogService.alert(
      addSupportTicketDialog.getOptions($event, {
        ticketType: 1,
        ticket,
        displayList: null,
        refreshTicket: vm.refreshTicket
      })
    );
    ssDialogService.show(ssDialogService.dialogs.support.addSupportTicketDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.home.contactUsDialog);
  }
}

ContactUsDialogController.$inject = [
  'addSupportTicketDialog',
  'ssDialogService',
  'loaderService',
  'orgDataService'
];
